import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Container,
  Typography,
  Button,
  Divider,
  IconButton,
} from "@mui/material";
import { FaLinkedin, FaInstagram, FaFacebook } from "react-icons/fa";

export default function PieDePagina() {
  const { t } = useTranslation();

  const socialLinks = [
    {
      href: "https://www.linkedin.com/company/consultoria-global-s-a-",
      icon: <FaLinkedin />,
      title: "LinkedIn",
    },
    {
      href: "https://www.instagram.com/consultoria_global/",
      icon: <FaInstagram />,
      title: "Instagram",
    },
    {
      href: "https://www.facebook.com/ConsultoriaGlobalSA/",
      icon: <FaFacebook />,
      title: "Facebook",
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
        background: "#0f172a",
        color: "#ffffff",
        pt: 8,
        pb: 4,
        px: { xs: 2, md: 6 },
        borderTop: "8px solid #0069a7",
        overflowX: "hidden",
      }}
    >
      <Container maxWidth="lg" disableGutters>
        {/* FOOTER TOP - FLEX CONTAINER TO AVOID DECIMAL GRID PROPS TYPE ERRORS */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "stretch",
            gap: 4,
            mb: 6,
          }}
        >
          {/* REDES SOCIALES */}
          <Box
            sx={{
              flex: { xs: "1 1 100%", sm: "1 1 45%", md: "1 1 18%" },
              display: "flex",
              flexDirection: "column",
              minHeight: "100%",
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                fontSize: "0.85rem",
                letterSpacing: "1px",
                mb: 1,
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  bottom: -6,
                  width: "25px",
                  height: "2px",
                  bgcolor: "primary.main",
                },
              }}
            >
              {t("footer.social_networks")}
            </Typography>
            <Box sx={{ display: "flex", gap: 1.5, mt: 2 }}>
              {socialLinks.map((social, index) => (
                <IconButton
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={social.title}
                  sx={{
                    color: "#94a3b8",
                    bgcolor: "#1e293b",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      color: "#ffffff",
                      bgcolor: "#0069a7",
                      transform: "translateY(-3px)",
                    },
                  }}
                >
                  {social.icon}
                </IconButton>
              ))}
            </Box>
          </Box>

          {/* ARGENTINA */}
          <Box
            sx={{
              flex: { xs: "1 1 100%", sm: "1 1 45%", md: "1 1 18%" },
              display: "flex",
              flexDirection: "column",
              minHeight: "100%",
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                fontSize: "0.85rem",
                letterSpacing: "1px",
                mb: 1,
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  bottom: -6,
                  width: "25px",
                  height: "2px",
                  bgcolor: "primary.main",
                },
              }}
            >
              {t("sedes.argentina.pais")}
            </Typography>
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: 0.5, mt: 2 }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: "primary.main",
                  fontSize: "0.85rem",
                }}
              >
                Buenos Aires
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#94a3b8", fontSize: "0.8rem", lineHeight: 1.6 }}
              >
                Sánchez de Loria 2395 <br />
                Piso 5° A <br />
                Polo Tecnológico de Buenos Aires
              </Typography>
            </Box>
          </Box>

          {/* ESPAÑA */}
          <Box
            sx={{
              flex: { xs: "1 1 100%", sm: "1 1 45%", md: "1 1 18%" },
              display: "flex",
              flexDirection: "column",
              minHeight: "100%",
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                fontSize: "0.85rem",
                letterSpacing: "1px",
                mb: 1,
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  bottom: -6,
                  width: "25px",
                  height: "2px",
                  bgcolor: "primary.main",
                },
              }}
            >
              {t("sedes.espana.pais")}
            </Typography>
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: 0.5, mt: 2 }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: "primary.main",
                  fontSize: "0.85rem",
                }}
              >
                Marbella
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#94a3b8", fontSize: "0.8rem", lineHeight: 1.6 }}
              >
                Av. Ricardo Soriano 18 <br />
                L22 <br />
                Centro de Negocios RS20
              </Typography>
            </Box>
          </Box>

          {/* CHILE */}
          <Box
            sx={{
              flex: { xs: "1 1 100%", sm: "1 1 45%", md: "1 1 18%" },
              display: "flex",
              flexDirection: "column",
              minHeight: "100%",
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                fontSize: "0.85rem",
                letterSpacing: "1px",
                mb: 1,
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  bottom: -6,
                  width: "25px",
                  height: "2px",
                  bgcolor: "primary.main",
                },
              }}
            >
              {t("sedes.chile.pais")}
            </Typography>
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: 0.5, mt: 2 }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: "primary.main",
                  fontSize: "0.85rem",
                }}
              >
                Santiago de Chile
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#94a3b8", fontSize: "0.8rem", lineHeight: 1.6 }}
              >
                Av. Apoquindo 5555 <br />
                Of. 1212, Edificio Andino
              </Typography>
            </Box>
          </Box>

          {/* CONTACTO */}
          <Box
            sx={{
              flex: { xs: "1 1 100%", sm: "1 1 45%", md: "1 1 18%" },
              display: "flex",
              flexDirection: "column",
              minHeight: "100%",
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                fontSize: "0.85rem",
                letterSpacing: "1px",
                mb: 1,
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  bottom: -6,
                  width: "25px",
                  height: "2px",
                  bgcolor: "primary.main",
                },
              }}
            >
              {t("footer.contact")}
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                mt: 2,
                color: "#94a3b8",
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontSize: "0.85rem", fontWeight: 500 }}
              >
                + 54 11 5219 4733
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontSize: "0.85rem", fontWeight: 500 }}
              >
                + 54 11 3988 6104
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* FOOTER BOTTOM */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            gap: 3,
          }}
        >
          {/* DATA FISCAL */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              flexDirection: "column",
              alignItems: { xs: "center", md: "flex-start" },
            }}
          >
            <Typography
              variant="overline"
              sx={{
                color: "#94a3b8",
                fontWeight: 700,
                mb: 1,
                display: "block",
              }}
            >
              {t("footer.data_fiscal")}
            </Typography>
            <a
              href="http://qr.afip.gob.ar/?qr=ItHVrtjHdz4tjHIftVnZ4A,,"
              target="_F960AFIPInfo"
              rel="noopener noreferrer"
            >
              <img
                src="/DATAWEB.webp"
                alt="DATA FISCAL"
                style={{
                  height: "70px",
                  borderRadius: "4px",
                  transition: "transform 0.3s ease",
                }}
                className="logo-hover"
              />
            </a>
          </Box>

          {/* POLICY SECTION & CERTIFICATIONS */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: { xs: "center", md: "flex-end" },
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "center", md: "flex-end" },
                gap: 1.5,
                width: "100%",
              }}
            >
              <Typography
                variant="body2"
                sx={{ color: "#94a3b8", fontSize: "0.8rem", fontWeight: 600 }}
              >
                {t("footer.policy_title")}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: { xs: "stretch", md: "center" },
                  justifyContent: { xs: "center", md: "flex-end" },
                  gap: 2,
                  width: "100%",
                  maxWidth: { xs: "260px", md: "none" },
                }}
              >
                <Button
                  component="a"
                  href="/Politica_Seguridad_de_la_Informacion_CG.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="outlined"
                  sx={{
                    color: "#ffffff",
                    borderColor: "#334155",
                    textTransform: "none",
                    fontSize: "0.8rem",
                    fontWeight: 600,
                    px: 3,
                    py: 0.8,
                    borderRadius: "4px",
                    width: { xs: "100%", md: "auto" },
                    "&:hover": {
                      borderColor: "primary.main",
                      backgroundColor: "rgba(0, 105, 167, 0.1)",
                    },
                  }}
                >
                  {t("footer.download") || "Descargar"}
                </Button>
                <img
                  src="/IRAM-ISO IEC 27001 IQNet mínimo.svg"
                  alt="IRAM ISO IEC 27001"
                  style={{
                    height: "72px",
                    width: "auto",
                    maxWidth: "100%",
                    borderRadius: "4px",
                    backgroundColor: "#fff",
                    padding: "4px",
                    objectFit: "contain",
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
        <Divider sx={{ borderColor: "#1e293b", mb: 4, padding: 2 }} />

        {/* COPYRIGHT */}
        <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              textAlign: "center",
              fontSize: "0.85rem",
            }}
          >
            {t("footer.copy", { year: new Date().getFullYear() })}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
